<template>
    <div>
        <div class="solution">
            <div class="tab">
                <div class="cells">
                    <div
                        class="cell"
                        v-for="(item,index) in menu"
                        :key="index"
                        :class="{on:item.show}"
                        @click="clickTabs(item,index)"
                    >
                        <h5>{{item.name}}</h5>
                    </div>
                </div>
            </div>
            <div class="appliances" v-show="menu[0].show">
                <ContentBox title="家电行业物流解决方案">
                    <div class="solution-img">
                        <viewer v-if="COMMON.isMobile">
                            <img src="../../images/picture/jdhy_main.png">
                        </viewer>
                        <img src="../../images/picture/jdhy_main.png" v-else>
                    </div>
                </ContentBox>
                <div class="appliances-2 bottom">
                    <ContentBox title="管理实践" text="统仓统配创新供应链，创造新价值">
                        <div class="content">
                            <div>
                                <img src="../../images/icon/icon_gylgh.png">
                                <h5>供应链规划</h5>
                            </div>
                            <div>
                                <img src="../../images/icon/icon_gxys.png">
                                <h5>干线运输</h5>
                            </div>
                            <div>
                                <img src="../../images/icon/icon_xsxx.png">
                                <h5>线上线下整合</h5>
                            </div>
                            <div>
                                <img src="../../images/icon/icon_csps.png">
                                <h5>城市配送</h5>
                            </div>
                            <div>
                                <img src="../../images/icon/icon_szyt.png">
                                <h5>送装一体</h5>
                            </div>
                            <div>
                                <img src="../../images/icon/icon_zhygl.png">
                                <h5>最后一公里</h5>
                            </div>
                        </div>
                    </ContentBox>
                </div>
            </div>
            <div class="consumer" v-show="menu[1].show">
                <ContentBox title="快消（食品、饮料、日化）行业物流解决方案">
                    <div class="solution-img">
                        <viewer v-if="COMMON.isMobile">
                            <img src="../../images/picture/rhhy_main.png">
                        </viewer>
                        <img src="../../images/picture/rhhy_main.png" v-else>
                    </div>
                </ContentBox>
                <div class="consumer-2 bottom">
                    <img class="consumer-line" src="../../images/icon/kxhy_line.png">
                    <ul class="content morethin">
                        <li>
                            <h5>可视干线</h5>
                            <p>采购物流</p>
                            <p>整车物流</p>
                            <p>零担物流</p>
                            <p>带板运输</p>
                        </li>
                        <li>
                            <h5>仓配一体</h5>
                            <p>智能云仓</p>
                            <p>B2B</p>
                            <p>B2C</p>
                            <p>管理输出</p>
                        </li>
                        <li>
                            <h5>智慧物流</h5>
                            <p>WMS</p>
                            <p>TMS</p>
                            <p>OMS</p>
                            <p>鲲鹏</p>
                        </li>
                        <li>
                            <h5>物流解决方案</h5>
                            <p>供应链布局优化</p>
                            <p>一体化分销</p>
                            <p>逆向物流解决方案</p>
                            <p>多仓可视化</p>
                        </li>
                    </ul>
                </div>
                <div class="cosmetic-2 bottom">
                    <div class="content">
                        <div>
                            <h5>取货路径规划与订单集拼</h5>
                            <p>集合美的、各生产厂的货量，统一调度车辆，规划线路。建立战略联盟，共享资源，实现规模效益</p>
                        </div>
                        <div>
                            <h5>物流网络规划</h5>
                            <p>根据行业的实际需求，对各级仓库进行重新选址，同时优化配送网络。降低层级，提升作业效率</p>
                        </div>
                        <div>
                            <h5>电商解决方案</h5>
                            <p>通过安得小件五大区域仓，实现电商仓配一体化业务，减少环节，降低成本</p>
                        </div>
                    </div>
                    <div class="content">
                        <div>
                            <h5>物流信息系统</h5>
                            <p>通过安得LMS大物流系统，实现全流程信息可视，使各环节更加可控。</p>
                        </div>
                        <div>
                            <h5>配送解决方案</h5>
                            <p>通过安得同城配送产品和零担产品，提供标准化的配送服务，通过标准化的服务实现降本增效</p>
                        </div>
                        <div class="content-disvisable">
                            <h5>配送解决方案</h5>
                            <p>通过安得同城配送产品和零担产品，提供标准化的配送服务，通过标准化的服务实现降本增效</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="distribution" v-show="menu[2].show">
                <ContentBox title="化工行业物流解决方案">
                    <div class="solution-img">
                        <viewer v-if="COMMON.isMobile">
                            <img src="../../images/picture/hg_main_bg.png">
                        </viewer>
                        <img src="../../images/picture/hg_main_bg.png" v-else>
                    </div>
                </ContentBox>
                <div class="distribution-2 bottom">
                    <div class="content">
                        <div class="content-line right-circle">
                            <div class="blue-icon">
                                <img src="../../images/icon/icon_logistic_cg.png">
                                <span>采购物流</span>
                            </div>
                            <div class="content-text">
                                <h5>仓储、运输、包装、进出口</h5>
                                <p>快速响应（周期短、时效高）
                                    <br>海量存储（立体库、平面库、移动库）
                                    <br>干线集拼（MILK-RUN、FTL）
                                    <br>品种多样（2000多SKU）
                                    <br>
                                </p>
                            </div>
                        </div>
                        <div class="arrow">
                            <img src="../../images/icon/logistic_jt.png">
                        </div>
                        <div class="content-line left-circle">
                            <div class="blue-icon">
                                <img src="../../images/icon/icon_logistic_sc.png">
                                <span>生产物流</span>
                            </div>
                            <div class="content-text">
                                <h5>VMI管理、工厂配送</h5>
                                <p>序列化（JIS、JIT、SPS）
                                    <br>智能化（暗灯、MES、LES）
                                    <br>机械化（AGV、自动分拣、自动仓储）
                                    <br>标准化（模块、工艺、包装、车辆）
                                    <br>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="distribution-arrow">
                        <div class="arrow-up">
                            <img src="../../images/icon/logistic_jt.png">
                        </div>
                        <div class="arrow-down">
                            <img src="../../images/icon/logistic_jt.png">
                        </div>
                    </div>
                    <div class="content">
                        <div class="content-line right-circle">
                            <div class="blue-icon">
                                <img src="../../images/icon/icon_logistic_nx.png">
                                <span>逆向物流</span>
                            </div>
                            <div class="content-text">
                                <h5>包装、索赔回收、废旧回收</h5>
                                <p>网点多（工厂至配套商、4S店至工厂）
                                    <br>IT支持（计划性、信息化）
                                    <br>
                                </p>
                            </div>
                        </div>
                        <div class="arrow-left">
                            <img src="../../images/icon/logistic_jt.png">
                        </div>
                        <div class="content-line left-circle">
                            <div class="blue-icon">
                                <img src="../../images/icon/icon_logistic_xs.png">
                                <span>销售物流</span>
                            </div>
                            <div class="content-text">
                                <h5>运输、RDC管理</h5>
                                <p>区域广（全国销售终端）
                                    <br>专业性（特种运输资源）
                                    <br>模式多（水、陆、铁）
                                    <br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
.solution {
    img {
        max-width: 100%;
    }
    .title {
        font-size: 32px;
        color: #333333;
        margin: 1em 0;
        text-align: center;
    }
    img {
        margin: 0 auto 0.64rem auto;
    }
    .solution-img {
        text-align: center;
    }
    .bottom {
        background-color: #f8f9fa;
    }
    .tab {
        .cells {
            display: flex;
            width: 12rem;
            margin: 0 auto;
        }
    }
    .cell {
        flex: 1;
        height: 0.6rem;
        cursor: pointer;
        margin: 0.5rem;
        background-color: #fafafa;
        border-radius: 0.5rem;
        h5 {
            font-size: 18px;
            color: #999999;
            width: 2rem;
            margin: 0.15rem auto;
            text-align: center;
        }
    }
    .on {
        background: #007eff;
        h5 {
            color: #ffffff;
        }
    }
    .appliances-2 {
        padding: 0.2rem 0 0.8rem 0;
        text-align: center;
    }

    .consumer-2 {
        padding: 0.6rem 0 0.8rem 0;
        text-align: center;
        .consumer-line {
            width: 1200px;
            height: 16px;
            margin-bottom: 0.3rem;
        }
    }
    .cosmetic-2 {
        padding: 0.6rem 0;
        background: #ffffff;
        .content {
            div {
                width: 2.7rem;
                background-color: #ffffff;
                border: solid 1px #e6e6e6;
                margin: 0.1rem;
                display: inline-block;
                padding: 0.3rem;
            }
            h5 {
                margin-bottom: 1.5em;
            }
        }
    }
    .appliances-2,
    .consumer-2,
    .cosmetic-2 {
        .content {
            display: flex;
            width: 12rem;
            margin: 0 auto;
            &.morethin {
                width: 10.7rem;
            }
            li,
            div {
                width: 2.5rem;
                flex: 1;
                display: inline-block;
            }
            img {
                width: 0.64rem;
                height: 0.64rem;
                margin: 0 auto;
                margin-bottom: 0.37rem;
            }
            h5 {
                font-size: 14px;
                color: #333333;
            }
        }
    }
    .distribution-2 {
        padding: 0.2rem 0 0.8rem 0;
        .title {
            padding: 0 0 0.26rem 0;
        }
        .content {
            display: flex;
            width: 12rem;
            margin: 0 auto;
            overflow: hidden;
            .content-line {
                width: 47%;
                background-color: #ffffff;
                border: solid 1px #e6e6e6;
                margin: 0.1rem;
                display: inline-block;
                padding: 0.2rem;
                height: 2rem;
                box-sizing: border-box;
            }
            h5 {
                font-size: .16rem;
                color: #333333;
                margin-bottom: 0.2rem;
            }
            p {
                color: #999999;
            }
            div {
                display: inline-block;
            }
        }
        .distribution-arrow {
            display: flex;
            justify-content: center;
            img {
                margin: 0;
            }
        }
        .arrow-up {
            margin-right: 2.2rem;
            img {
                transform: rotate(270deg);
            }
        }
        .arrow-down {
            img {
                transform: rotate(90deg);
            }
        }
        .arrow-left {
            img {
                transform: rotate(180deg);
            }
        }
        .arrow,
        .arrow-left {
            padding-top: 1rem;
        }
        .blue-icon {
            height: 1.6rem;
            width: 1.6rem;
            background-image: linear-gradient(0deg, #007eff 0%, #05d5ff 100%);
            border-radius: 50%;
            img {
                margin: 0.4rem auto 0.1rem auto;
                display: block;
            }
            span {
                display: block;
                color: #fff;
                text-align: center;
            }
        }
        .right-circle {
            border-radius: 0 1rem 1rem 0;
            .blue-icon {
                float: right;
            }
        }
        .left-circle {
            border-radius: 1rem 0 0 1rem;
            .blue-icon {
                float: left;
            }
        }
        .content-text {
            margin-left: 0.4rem;
            width: 60%;
            p{
                font-size: 0.14rem;
            }
        }
    }
    .content-disvisable {
        visibility: hidden;
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .solution {
        .cosmetic-2 .content {
            h5 {
                margin-bottom: 0.1rem;
            }
        }
        .cell h5 {
            font-size: 16px;
        }
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .solution {
        .cosmetic-2 .content {
            h5 {
                margin-bottom: 0.1rem;
                font-size: 12px;
            }
        }
        .cell h5 {
            font-size: 14px;
        }
    }
}

@media screen and (max-width: 480px) {
    .solution {
        .solution-img {
            padding: 0 0.15rem 0.15rem;
        }
        .title {
            font-size: 16px;
        }
        .tab {
            display: none;
        }
        .consumer-2,
        .cosmetic-2,
        .appliances-2 {
            .content {
                flex-wrap: wrap;
                width: 100%;
                div {
                    width: 30%;
                    min-width: 30%;
                    margin-bottom: 0.1rem;
                }
                img {
                    width: 0.32rem;
                    height: 0.32rem;
                    margin-bottom: 0;
                }
                h5,
                p {
                    font-size: 12px;
                }
                &.morethin {
                    width: 100%;
                    display: block;
                    padding: 0.15rem 0.15rem 0.05rem;
                    box-sizing: border-box;
                    border-left: 1px solid #ff8b00;
                    li {
                        width: 100%;
                        min-width: auto;
                        text-align: left;
                        box-sizing: border-box;
                        margin-bottom: 0.2rem;
                        position: relative;
                        &:before {
                            content: "";
                            display: block;
                            width: 0.1rem;
                            height: 0.1rem;
                            background: #ff8b00;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.2rem;
                            top: 0.05rem;
                        }
                        h5 {
                            margin-bottom: 0.05rem;
                        }
                        p {
                            display: inline-block;
                            margin-right: 0.1rem;
                        }
                    }
                }
            }
        }
        img {
            margin: 0 auto 0.16rem auto;
        }
        .appliances {
            padding: 0.15rem 0 0 0;
        }
        .consumer-2,
        .cosmetic-2,
        .appliances-2,
        .distribution-2 {
            padding: 0.15rem 0 0.2rem 0;
        }
        .cosmetic-2 {
            .content {
                width: 100%;
                padding: 0 0.15rem;
                box-sizing: border-box;
                flex-wrap: wrap;
                div {
                    margin: 0 0 0.1rem;
                    padding: 0.15rem;
                    height: auto;
                    width: 100%;
                    min-width: 2rem;
                }
                h5 {
                    font-size: 14px;
                    margin-bottom: 0.05rem;
                }
            }
        }
        .consumer-2 {
            padding: 0.15rem 0.15rem 0.15rem 0.2rem;
            .consumer-line {
                display: none;
            }
        }
        .distribution-2 {
            .title {
                padding-bottom: 0;
            }
            .content {
                display: flex;
                width: 100%;
                margin: 0 auto;
                flex-wrap: wrap;
                .content-line {
                    width: 100%;
                    background-color: #ffffff;
                    border: solid 1px #e6e6e6;
                    margin: 0.05rem 0.15rem;
                    display: flex;
                    padding: 0.15rem;
                    height: auto;
                    align-items: center;
                }
                h5 {
                    margin-bottom: 0.15rem;
                }
                p {
                    color: #999999;
                }
                div {
                    display: inline-block;
                }
            }

            .blue-icon {
                height: 0.8rem;
                width: 0.8rem;
                background-image: linear-gradient(
                    0deg,
                    #007eff 0%,
                    #05d5ff 100%
                );
                border-radius: 50%;
                flex-shrink: 0;
                img {
                    margin: 0.15rem auto 0.05rem auto;
                    display: block;
                    width: 50%;
                }
                span {
                    display: block;
                    color: #fff;
                    text-align: center;
                }
            }
            .right-circle {
                border-radius: 0;
                .blue-icon {
                    float: none;
                }
            }
            .left-circle {
                border-radius: 0;
                .blue-icon {
                    float: none;
                }
            }
            .content-text {
                margin-left: 0.15rem;
            }
            .arrow,
            .arrow-left,
            .distribution-arrow {
                display: none !important;
            }
        }
        .content-disvisable {
            display: none !important;
        }
    }
}
</style>
<script>
import ContentBox from '../common/content-box';
export default {
    metaInfo: {
        title: '安得智联-行业方解决方案',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '安得智联行业解决方案'
        },{                 // set meta
            name: 'description',
            content: '安得智联行业方解决方案,针对泛家电家居、泛快消、电商（含B2B平台）、经销等行业提供专业物流解决方案.'
        }]
    },
    name: 'solution',
    data() {
        return {
            menu: [
                {
                    name: '家电行业',
                    show: true
                },
                {
                    name: '快消行业',
                    show: false
                },
                {
                    name: '化工行业',
                    show: false
                }
            ]
        };
    },
    methods: {
        clickTabs(item, index) {
            this.menu.map(sitem => {
                sitem.show = false;
            });
            this.menu[index].show = true;
        }
    },
    mounted() {
        if (this.COMMON.isMobile) {
            this.menu.forEach(item => (item.show = true));
        }
    },
    components: {
        ContentBox
    }
};
</script>